module.exports = __webpack_public_path__ + "img/Mini_arrow_bot2.56f1afbd.png";